import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styles from './WhyUs.module.css';

const reasons = [
  { icon: '🏅', title: 'BC Incorporated & Insured', desc: 'Legally incorporated in British Columbia (BC1585120). We carry full liability insurance — your property and investment are always protected.' },
  { icon: '🔧', title: 'Trade-Level Expertise', desc: 'Enes brings years of hands-on construction experience across framing, cladding, waterproofing, and finishing. We know the craft, not just the basics.' },
  { icon: '📋', title: 'Free On-Site Estimates', desc: 'We visit your property, assess the scope, and provide a clear, itemised quote — no hidden fees, no pressure. Just honest pricing.' },
  { icon: '📅', title: 'On-Time Delivery', desc: 'We respect your schedule. Projects are planned carefully, communicated clearly, and completed on time without cutting corners.' },
  { icon: '🤝', title: 'Client-First Approach', desc: 'We listen before we act. Your vision and budget guide every decision. Regular updates keep you informed from start to final walkthrough.' },
  { icon: '✅', title: 'Quality Guaranteed', desc: 'Every project is inspected before sign-off. We stand behind our work — if something is not right, we make it right. That is our commitment.' },
];

export default function WhyUs() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.08 });

  return (
    <section id="whyus" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <motion.div
          className={styles.header}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className={styles.label}><span className={styles.labelLine} />Why Choose Us</span>
          <h2 className={styles.heading}>
            The AussieSpec <span className={styles.accent}>Difference</span>
          </h2>
        </motion.div>

        <div className={styles.grid}>
          {reasons.map((r, i) => (
            <motion.div
              key={r.title}
              className={styles.card}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.08 * i }}
            >
              <span className={styles.icon}>{r.icon}</span>
              <h3 className={styles.cardTitle}>{r.title}</h3>
              <p className={styles.cardDesc}>{r.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Bottom quote */}
        <motion.div
          className={styles.quote}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.7 }}
        >
          <span className={styles.quoteBar} />
          <blockquote>
            "We treat every project like it is our own home. Attention to detail, proper materials,
            and honest work — that is how AussieSpec operates."
          </blockquote>
          <cite>— Enes Calimli, Founder</cite>
        </motion.div>
      </div>
    </section>
  );
}
